var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrugvlabLogoDarkMode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 650,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 238,
    width: 1190,
    height: 521
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1818.5 262.695 1897.06 348.184 1811.57 426.738 1733.01 341.249Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1818.5 262.695 1897.06 348.184 1811.57 426.738 1733.01 341.249Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1818.5 262.695 1897.06 348.184 1811.57 426.738 1733.01 341.249Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-997 -238)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1831.4 362.526C1841.97 352.813 1839.51 340.607 1836.38 328.622 1848.06 332.751 1860.01 336.236 1870.58 326.523L1868.95 324.742C1866.83 326.733 1864.32 328.263 1861.58 329.233L1834.39 299.647C1835.59 296.998 1837.33 294.626 1839.49 292.683L1837.85 290.902C1827.28 300.616 1829.75 312.822 1832.87 324.807 1821.2 320.677 1809.24 317.193 1798.67 326.906 1788.1 336.62 1790.56 348.826 1793.69 360.811 1782.01 356.681 1770.06 353.197 1759.49 362.91L1761.13 364.691C1763.24 362.7 1765.75 361.17 1768.49 360.2L1795.68 389.786C1794.48 392.435 1792.75 394.807 1790.58 396.75L1792.22 398.531C1802.79 388.817 1800.33 376.611 1797.2 364.626 1808.88 368.755 1820.83 372.24 1831.4 362.526ZM1833.45 302.194 1858.96 329.96C1851.64 331.404 1843.79 328.701 1835.63 325.789 1833.42 317.418 1831.39 309.371 1833.45 302.194ZM1833.62 327.64C1835.83 336.011 1837.87 344.057 1835.81 351.235L1810.29 323.469C1817.62 322.025 1825.47 324.728 1833.62 327.64ZM1807.68 324.196 1834.86 353.782C1832.38 359.098 1827.9 363.217 1822.4 365.237L1795.21 335.651C1797.69 330.335 1802.17 326.216 1807.68 324.196ZM1796.62 387.237 1771.11 359.473C1778.44 358.029 1786.28 360.732 1794.44 363.644 1796.65 372.015 1798.68 380.062 1796.63 387.239ZM1796.45 361.793C1794.24 353.422 1792.21 345.375 1794.26 338.198L1819.78 365.964C1812.45 367.408 1804.61 364.705 1796.45 361.793Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.20937,
    fill: "#FFFFFF"
  })))), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 248,
    transform: "matrix(1 0 0 1 1165.03 545)"
  }, "rug"), /*#__PURE__*/React.createElement("text", {
    fill: "#F7AC34",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 700,
    fontSize: 248,
    transform: "matrix(1 0 0 1 1497.9 545)"
  }, "V"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 700,
    fontSize: 248,
    transform: "matrix(1 0 0 1 1643.99 545)"
  }, "LAB"), /*#__PURE__*/React.createElement("path", {
    d: "M1040.52 371.452 1034.72 369.49C1030.2 369.49 1026.53 372.489 1026.53 376.188L1026.53 502.909C1026.53 506.607 1030.2 509.606 1034.72 509.606 1039.25 509.606 1042.92 506.607 1042.92 502.909L1042.92 376.188C1042.92 374.338 1042 372.664 1040.52 371.452ZM1124.49 381.164C1141.05 397.564 1151 418.588 1151 441.512 1151 493.908 1049.78 535.151 1034.89 536.384 1020 537.617 1014.44 537.204 1011.89 533.245 994.16 490.223 990.591 381.498 1010.37 348.191 1011.89 345.029 1015.41 343.692 1034.89 346.639 1053.11 349.396 1095.98 357.258 1116.99 374.427 1119.62 376.573 1122.12 378.821 1124.49 381.164Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrugvlabLogoDarkMode);
export default __webpack_public_path__ + "static/media/drugvlab_logo_dark_mode.bfb02fefb84c26aaf294540ee685c725.svg";
export { ForwardRef as ReactComponent };